import { Box, Group, Text } from '@mantine/core';
import { brand } from '@/theme/theme';

export interface SectionDividerProps {
  label: string;
}

/** Dark pill + yellow dot + uppercase label, followed by a hairline. See frontend-design.md §5.1. */
export function SectionDivider({ label }: SectionDividerProps) {
  return (
    <Group gap="sm" wrap="nowrap" my="md">
      {/* A long label wraps inside the pill rather than pushing the page wider than a phone. */}
      <Group gap={6} wrap="nowrap" bg={brand.dark} px={10} py={4} style={{ borderRadius: 14, minWidth: 0, maxWidth: '100%' }}>
        <Box w={8} h={8} bg={brand.yellow} style={{ borderRadius: '50%', flexShrink: 0 }} />
        <Text fz={12} fw={700} tt="uppercase" c={brand.onDark} style={{ letterSpacing: '0.1em', minWidth: 0, overflowWrap: 'break-word' }}>
          {label}
        </Text>
      </Group>
      <Box style={{ flex: 1, minWidth: 24, height: 1, backgroundColor: brand.border }} />
    </Group>
  );
}
